<template>
  <div class="card mb-0 border-0 shadow-0 ">
    <div class="card-body text-center" :class="{ 'py-5 mb-5': !isCloseSpan }">
      <div class="mt-5 mb-3">
        <img
          src="@/assets/images/no_access_img.png"
          width="200px"
        >
      </div>
      <h1 class="error-page-title">
        {{ $t('Access Denied') }}!
      </h1>
      <div class="error-page-text">
        <div>{{ $t('You do not have permission to access this page.') }}</div>
        <div>{{ $t('If you feel this is a mistake, contact your admin.') }}</div>
      </div>
      <div
        class="mt-4"
      >
        <button
          v-if="showButton"
          class="btn btn-lg btn-primary"
          @click="clickGoBack()"
        >
          <i class="fas fa-arrow-alt-circle-left mr-2" />
          {{ showButtonText ? $t(showButtonText) : $t('Go Back') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    components: {},
    props: {
        showButton: {
          type: [String, Boolean],
          default: false
        },
        currentModal: {
          type: [String],
          default: ''
        },
        backToModal: {
          type: [String],
          default: ''
        },
        isCloseModal: {
          type: [String, Boolean],
          default: false
        },
        showButtonText: {
          type: [String, Boolean],
          default: false
        },
        isCloseSpan: {
          type: [String, Boolean],
          default: false
        },
    },
    data() {
        return {

        }
    },
    methods: {
        clickGoBack(){
          if(this.isCloseModal){
            this.$parent.closeModal();
          }else{
            this.$parent.closeModalForm();
          }
        }
    },
};
</script>
